import { useMutation, useQueryClient } from "@tanstack/react-query";
import { message } from "antd";
import createPrivateAdminPanelInstance from "../../api/PrivateAdminPanelInstance";
import { API_ROUTES } from "../../api/ApiRoutes";

import { AppStrings } from "../../utils/constants/AppStrings";
import { getApiErrorMessage } from "../../utils/ErrorUtils";
import { bonusAdminEnvelope } from "./bonusAdminBody";
import { getSegmentQueryKey } from "./useGetSegment";
import { LIST_SEGMENTS_QUERY_KEY } from "./useListSegments";

type StoredToken = { AccessToken?: string };
export type SegmentTransitionAction = "activate" | "pause";

const ROUTE_MAP: Record<SegmentTransitionAction, string> = {
  activate: API_ROUTES.ACTIVATE_DYNAMIC_BONUS_SEGMENT,
  pause:    API_ROUTES.PAUSE_DYNAMIC_BONUS_SEGMENT,
};

async function postTransition(
  segmentId: string,
  action: SegmentTransitionAction,
): Promise<string | undefined> {
  const tokenString = localStorage.getItem("token");
  const token: StoredToken | null = tokenString ? JSON.parse(tokenString) : null;
  const instance = createPrivateAdminPanelInstance(token?.AccessToken);
  const url = ROUTE_MAP[action].replace("{segment_id}", segmentId);
  const response = await instance.post(url);
  return bonusAdminEnvelope(response).message;
}

export const useSegmentTransition = (segmentId: string) => {
  const queryClient = useQueryClient();

  return useMutation<string | undefined, Error, SegmentTransitionAction>({
    mutationFn: (action) => postTransition(segmentId, action),
    onSuccess: (beMessage) => {
      queryClient.invalidateQueries({ queryKey: LIST_SEGMENTS_QUERY_KEY });
      queryClient.invalidateQueries({ queryKey: getSegmentQueryKey(segmentId) });
      message.success(beMessage || AppStrings.PAM_GENERIC_REQUEST_SUCCEEDED);
    },
    onError: (error) => {
      message.error(getApiErrorMessage(error, AppStrings.PAM_GENERIC_REQUEST_FAILED));
    },
  });
};
